// extracted by mini-css-extract-plugin
export var container = "ProductDescription-module--container--3LyXy";
export var content = "ProductDescription-module--content--5BlXx";
export var gallery = "ProductDescription-module--gallery--3L85C";